import { type FC } from 'react';
import { useDispatch } from 'react-redux';

import { acceptCurrentChange } from '@editor2/reducers/editor/editorSlice';
import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import AcceptButton from './AcceptButton';

interface Props {
	courseId: number;
	conflict: Conflict | ReorderConflict;
	showButton: boolean;
}

const CurrentChangesDivider: FC<Props> = (props) => {
	const { courseId, conflict, showButton } = props;

	const dispatch = useDispatch();

	const keepYourChangesTooltip =
		'Throw away the incoming conflicting change, retaining your change.';

	const onAcceptCurrentClick = () => {
		dispatch(acceptCurrentChange({ courseId, conflict }));
	};

	return (
		<div className="changesDivider">
			<span className="divider-text">[ Your change ]</span>

			{showButton && (
				<AcceptButton
					name="Keep your changes"
					variant="outline-primary"
					tooltip={keepYourChangesTooltip}
					onAcceptClick={() => onAcceptCurrentClick()}
				/>
			)}
		</div>
	);
};

export default CurrentChangesDivider;
